import * as React from "react";
import type { SVGProps } from "react";
const SvgVoucherEliza = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#d10047"
      d="M17 5h3c1.1 0 2 .98 2 2.18V10a2 2 0 1 0 0 4v2.82c0 1.2-.9 2.18-2 2.18h-3zm-1 0H4c-1.1 0-2 .98-2 2.18V10a2 2 0 1 1 0 4v2.82c0 1.2.9 2.18 2 2.18h12z"
    />
    <path
      fill="#fff"
      d="m13.3 13.56-.09-.07-1.02-.8.94-.09q.54-.02.92-.41a.8.8 0 0 0 .1-.71s-.17-.56-.37-.52l-.6.08-.3.04-1.76.16.37-.89.41-1.05a.7.7 0 0 0 .04-.55.7.7 0 0 0-.42-.37l-.14-.05a.63.63 0 0 0-.91.42l-.42 1.02q-.2.46-.42 1.05L8.21 9.73q-.22-.16-.42-.34l-.25-.23a.8.8 0 0 0-.62-.21.7.7 0 0 0-.42.33l-.07.12q-.15.21-.17.47a.6.6 0 0 0 .27.46l.22.2.47.42.86.64-1.59.24a.8.8 0 0 0-.59.35.6.6 0 0 0 0 .55l.05.13q.1.24.28.42a.5.5 0 0 0 .5.05l.44-.07 1.63-.23q-.26.71-.42 1.45a1.3 1.3 0 0 0 .08 1.01.9.9 0 0 0 .59.38l.25.02c.17 0 .36-.04.39-.15q.24-1.27.68-2.5l1.37 1.02.28.17.15.09h.03l.07.03.11.05q.21.05.42.02a.5.5 0 0 0 .33-.2.4.4 0 0 0 .06-.2v-.2c.08-.13.02-.3.11-.26.1.03.26-.02 0-.22z"
    />
  </svg>
);
export default SvgVoucherEliza;
